<template>
    <div class="about-us-section" id="about-us">
        <div class="container">
            <div class="column-container">
                <div class="col-left">
                    <div class="about-section-title">
                        <h2>{{ aboutPage.about_title }}</h2>
                    </div>
                    <div class="col-desc" v-html="aboutPage.about_desc"></div>
                </div>
                <div class="col-right">
                    <div class="about-video" :style="'background-image:url(' + aboutPage.about_img_prev + ')'">
                        <div class="video-link" @click="initVideo = true" v-if="!initVideo">
                            <div class="icon-play-container">
                                <svgIcon name="play" class="icon-play"/>
                            </div>
                        </div>
                        <div class="video-player" v-if="initVideo">
                            <iframe :src="aboutPage.about_video_link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'about-us-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                initVideo: false,
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about/about-us-section.scss';
    @import '@/styles/components/about/respond/about-us-section-respond.scss';
</style>